import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { INBOX_BACKEND_URL } from 'src/services/constants/urls'
import {
  DisconnectPageParams,
  DisconnectPageResponse,
  UseDisconnectPageMutationParams,
} from './interfaces/useDisconnectPageMutation.interface'

const disconnectPage = async ({
  userId,
  pageId,
}: DisconnectPageParams): Promise<DisconnectPageResponse> => {
  const response = await axios.delete(
    `${INBOX_BACKEND_URL}/pages/${userId}/${pageId}`
  )

  return response.data
}

export const useDisconnectPageMutation = ({
  onError,
  onSuccess,
}: UseDisconnectPageMutationParams = {}) => {
  return useMutation({
    mutationFn: disconnectPage,
    onError: () => {
      if (onError) {
        onError()
      }
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess()
      }
    },
  })
}
